import { useMemo } from 'react';
import Auth from '../Auth';
import useInspireOptions from './useInspireOptions';

const useIsAdminOrImpersonating = () => {
  const { isAdmin } = useInspireOptions();

  return useMemo(() => {
    return isAdmin || Auth.isImpersonating();
  }, [isAdmin]);
};

export default useIsAdminOrImpersonating;
